import { Route } from 'react-router-dom';
import { nhAppMainPages } from '@pflegenavi/frontend/routing';
import { useFeatureFlag } from '@pflegenavi/frontend/feature-flags';
import { FeatureFlag, FeatureFlagStatus } from '@pflegenavi/shared/api';
import { lazy, useMemo, type JSX } from 'react';
import { DefaultSuspense } from '@pflegenavi/web-components';

const BudgetsPage = lazy(() => import('./BudgetsPage'));

export const useBudgetsRoutes = (): JSX.Element | null => {
  const expenseManagementEnabled =
    useFeatureFlag(FeatureFlag.ExpenseManagement) === FeatureFlagStatus.Enabled;

  return useMemo(() => {
    if (!expenseManagementEnabled) {
      return null;
    }

    return (
      <Route
        path={nhAppMainPages.BUDGETS}
        element={
          <DefaultSuspense>
            <BudgetsPage />
          </DefaultSuspense>
        }
      />
    );
  }, [expenseManagementEnabled]);
};
